import React, {
  useCallback,
  useEffect,
  useState,
  useContext,

} from "react";
import { useParams } from "react-router-dom";
import { AuthContext } from "../../AuthContext";
import { useMsal } from "@azure/msal-react";
import { protectedResources } from "../../msalConfig";
import ReactFlow, {
  addEdge,
  Background,
  MiniMap,
  MarkerType,
  useNodesState,
  useEdgesState,
  Controls,
} from "reactflow";

import "reactflow/dist/style.css";
import dagre from "dagre";
import { GetToken } from "../../GetTokentComponent";
import { DATABOOK_API } from "../../constants/serverConfig";
import { TELEMETRY_API } from "../../constants/serverConfig";
import axios from "axios";
import _ from "lodash";
import CustomNodeUpdater from "./CustomNodeUpdater";
import { VscSettingsGear } from "react-icons/vsc";
import { BsFillDatabaseFill } from "react-icons/bs";
import DetailsCard from "../Datasets/AllDataSets/Individual/IndividualDataTabs/DetailsOverview/DetailsCard.js";
import {
  setCertifiedDatasetsFunction,
  setMetricsDataFunction,
  setPastOneMonthUserVisitFunction,
} from "./InfoDetailsService";
import { Col, Row } from "react-bootstrap";

const nodeTypes = { customUpdater: CustomNodeUpdater };

const ReactFlowChart = (props) => {

  const [updatedNodes, setUpdatedNodes] = useState([]);
  const [updatedEdges, setUpdatedEdges] = useState([]);
  // const [infodata, setInfodata] = useState([]);

  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const request = {
    scopes: protectedResources.databook.scopes,
    account: account,
  };
  let apiParameter = {
    instance,
    account,
    request,
  };

  const [captureElementClick, setCaptureElementClick] = useState(false);

  const [infoOnClick, setInfoOnClick] = useState(false);
  const [firstNodeInfoClick, setFirstNodeInfoClick] = useState(false);
  const [clickedNodeInfo, setClickedNodeInfo] = useState([]);
  const [certifiedetails, setCertifiedDatasets] = useState({});
  const [modaldata, setModalData] = useState([]);
  const [metricsdata, setmetricsData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [oneMonthUserVisitCount, setPastOneMonthUserVisit] = useState("");
  const [show, setShow] = useState(true);

  const onClick = async (event, node) => {
    setShow(true);
    setFirstNodeInfoClick(false);
    setInfoOnClick(true);

    let nodeId;
    node.includes("/") ? (nodeId = node.replaceAll("/", "|")) : (nodeId = node);
    setClickedNodeInfo(nodeId);

    const COLUMN_API = `${DATABOOK_API}/datasets/${nodeId}`;
    const METRICS_API = `${TELEMETRY_API}metrics/latest?object_id=${nodeId}`;

    try {
      const token = await GetToken(apiParameter);
      if (token) {
        await getInfoDetails(token, COLUMN_API, node);
        getdetailsmetricsdata(token, METRICS_API);
        getUserVisitInPastOneMonth(token);
      }
    } catch (error) {
      console.error("API request error:", error);
    }
  };

  const getInfoDetails = setCertifiedDatasetsFunction(
    setModalData,
    setCertifiedDatasets
  );

  const getdetailsmetricsdata = setMetricsDataFunction(
    setIsFetching,
    clickedNodeInfo,
    setmetricsData
  );

  const getUserVisitInPastOneMonth = setPastOneMonthUserVisitFunction(
    clickedNodeInfo,
    setPastOneMonthUserVisit
  );

  useEffect(() => {
    setNodes(props.initialsNode);
    setEdges(props.initialsedge);
    setShow(props.showDetails);
    setInfoOnClick(false);
    setFirstNodeInfoClick(props.infoClick);
    // setInfoOnClick(props.infoClick);
    let nodeId;
    props.nodeClick.includes("/")
      ? (nodeId = props.nodeClick.replaceAll("/", "|"))
      : (nodeId = props.nodeClick);
    setClickedNodeInfo(nodeId);
  }, [props]);

  const dagreGraph = new dagre.graphlib.Graph();
  dagreGraph.setDefaultEdgeLabel(() => ({}));

  const nodeWidth = 172;
  const nodeHeight = 36;

  const getLayoutedElements = (nodes, edges, direction = "LR") => {
    const isHorizontal = direction === "LR";
    dagreGraph.setGraph({ rankdir: direction });

    nodes.forEach((node) => {
      dagreGraph.setNode(node.id, { width: nodeWidth, height: nodeHeight });
    });

    edges.forEach((edge) => {
      dagreGraph.setEdge(edge.source, edge.target);
    });

    dagre.layout(dagreGraph);

    nodes.forEach((node) => {
      const nodeWithPosition = dagreGraph.node(node.id);
      node.targetPosition = isHorizontal ? "left" : "top";
      node.sourcePosition = isHorizontal ? "right" : "bottom";

      // We are shifting the dagre node position (anchor=center center) to the top left
      // so it matches the React Flow node anchor point (top left).
      node.position = {
        x: nodeWithPosition.x - nodeWidth / 2,
        y: nodeWithPosition.y - nodeHeight / 2,
      };

      return node;
    });

    return { nodes, edges };
  };

  const onConnect = useCallback(
    (params) =>
      setEdges((eds) =>
        addEdge({ ...params, type: MarkerType.Arrow, animated: true }, eds)
      ),
    []
  );

  const { nodes: layoutedNodes, edges: layoutedEdges } = getLayoutedElements(
    props.initialsNode,
    props.initialsedge
  );

  const [nodes, setNodes, onNodesChange] = useNodesState(layoutedNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(layoutedEdges);

  const { Unodes: layoutedUNodes, Uedges: layoutedUEdges } =
    getLayoutedElements(updatedNodes, updatedEdges);

  const [Unodes, setUNodes, onUNodesChange] = useNodesState(layoutedUNodes);
  const [Uedges, setUEdges, onUEdgesChange] = useEdgesState(layoutedUEdges);

  const mergeNodedata = async (event, node) => {
    setCaptureElementClick(true);

    let nodeId;
    node.fqn.includes("/")
      ? (nodeId = node.fqn.replaceAll("/", "|"))
      : (nodeId = node.fqn);

    var onClickURL;

    if (node.data.nodeType === "dataset") {
      onClickURL = `${DATABOOK_API}/lineage/datasets/${nodeId}/Any/2`;
    } else {
      onClickURL = `${DATABOOK_API}/lineage/tasks/${nodeId}/Any/2`;
    }

    try {
      const token = await GetToken(apiParameter);
      if (token) {
        await getLineageData(token, onClickURL, node);
      }
    } catch (error) {
      console.error("API request error:", error);
    }
  };

  const getLineageData = async (token, onClickURL, node) => {
    axios
      .get(onClickURL, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        let data = res.data;

        transformDataToElements(data, node);
      });
  };

  const transformDataToElements = (data, node) => {
    var initilarray = [...props.initialsNode];

    const sourceNode = [
      {
        id: node.id,
        data: { label: node.data.label },
        fqn: node.fqn,
      },
    ];

    var afterAddingSource = [...initilarray, ...sourceNode];

    var afterInbound = [];
    var input = [];
    if (data.inbound && data.inbound.length > 0) {
      input = data.inbound.map((inboundNode) => {
        let edgeId = inboundNode.edge.edgeFrom.split("/").pop();
        let dataLabel = inboundNode.node.fqn;
        let formattedDataLabel;

        // Disabling for pipedream dataset
        // if (inboundNode.node.name) {
        //   formattedDataLabel = inboundNode.node.name;
        // } else {

        switch (true) {
          case dataLabel.includes("sqlserver"):
            formattedDataLabel = dataLabel.split("~~~")[0];
            break;
          case dataLabel.includes("/"):
            formattedDataLabel = dataLabel.split("/").splice(-1);
            break;
          case dataLabel.includes("."):
            formattedDataLabel = dataLabel.split(".").splice(-1);
            break;
          default:
            formattedDataLabel = dataLabel.split("_").splice(-1);
            break;
        }
        // }


        return {
          // id: nodeId,
          id: edgeId,
          type: "customUpdater",
          data: {
            label: formattedDataLabel,
            nodeType: inboundNode.edge.edgeType,
            dataIcon: <BsFillDatabaseFill color="#42b0d5" />,
            taskIcon: <VscSettingsGear color="#fa6a55" />,
            onClick: (event) => onClick(event, inboundNode.node.fqn),
          },
          fqn: inboundNode.node.fqn,
        };
      });
    }
    afterInbound = [...afterAddingSource, ...input];

    var output = [];
    if (data.outbound && data.outbound.length > 0) {
      output = data.outbound.map((outboundNode) => {
        let nodeId;
        outboundNode.node.hasOwnProperty("versionId")
          ? (nodeId = outboundNode.node.fqn.concat(
            "_" + outboundNode.node.versionId
          ))
          : (nodeId = outboundNode.node.fqn);

        let edgeId = outboundNode.edge.edgeTo.split("/").pop();
        let dataLabel = outboundNode.node.fqn;

        let formattedDataLabel;
        // Disabling for pipedream dataset
        // if (outboundNode.node.name) {
        //   formattedDataLabel = outboundNode.node.name;
        // } else {
        switch (true) {
          case dataLabel.includes("sqlserver"):
            formattedDataLabel = dataLabel.split("~~~")[0];
            break;
          case dataLabel.includes("/"):
            formattedDataLabel = dataLabel.split("/").splice(-1);
            break;
          case dataLabel.includes("."):
            formattedDataLabel = dataLabel.split(".").splice(-1);
            break;
          default:
            formattedDataLabel = dataLabel.split("_").splice(-1);
            break;
        }
        // }


        return {
          // id: nodeId,
          id: edgeId,
          type: "customUpdater",
          data: {
            label: formattedDataLabel,
            nodeType: outboundNode.edge.edgeType,
            dataIcon: <BsFillDatabaseFill color="#42b0d5" />,
            taskIcon: <VscSettingsGear color="#fa6a55" />,
            onClick: (event) => onClick(event, outboundNode.node.fqn),
          },
          fqn: outboundNode.node.fqn,
        };
      });
    }

    setUpdatedNodes([...afterInbound, ...output]);

    var finalnodes = [...afterInbound, ...output];

    var uniqueNodes = _.uniqBy(finalnodes, "id");

    setUpdatedNodes(uniqueNodes);

    const inputEdge = data.inbound.map((inboundNode) => {
      return {
        id: inboundNode.edge.edgeId,
        source: inboundNode.edge.edgeFrom.split("/").pop(),
        target: inboundNode.edge.edgeTo.split("/").pop(),
        animated: true,
        markerEnd: {
          type: MarkerType.ArrowClosed,
        },
      };
    });
    const outputEdge = data.outbound.map((outboundNode) => {
      return {
        id: outboundNode.edge.edgeId,
        source: outboundNode.edge.edgeFrom.split("/").pop(),
        target: outboundNode.edge.edgeTo.split("/").pop(),
        animated: true,
        markerEnd: {
          type: MarkerType.ArrowClosed,
        },
      };
    });

    let finaledges = props.initialsedge.concat(inputEdge).concat(outputEdge);

    let uniqueEdges = _.uniqBy(finaledges, "id");

    setUpdatedEdges(uniqueEdges);

    setUNodes(uniqueNodes);

    setUEdges(uniqueEdges);
  };

  // const handleShow = () => {
  //   setShow(false);
  // };
  return (
    <>
      <>
        <div
          style={
            props.fullScreenHandleActive
              ? {
                width: "100%",
                // height: "60vh",
                height: "100vh",
                // paddingTop: "1rem",
              }
              : {
                width: "100%",
                // height: "60vh",
                height: "600px",
                // paddingTop: "1rem",
              }
          }
        >
          {!captureElementClick ? (
            <ReactFlow
              nodes={nodes}
              edges={edges}
              onNodesChange={onNodesChange}
              onEdgesChange={onEdgesChange}
              onConnect={onConnect}
              onNodeClick={mergeNodedata}
              nodeTypes={nodeTypes}
            >
              <Controls showInteractive={false} />
              <MiniMap zoomable pannable />
              <Background />
            </ReactFlow>
          ) : (
            <ReactFlow
              nodes={Unodes}
              edges={Uedges}
              onNodesChange={onNodesChange}
              onEdgesChange={onEdgesChange}
              onConnect={onConnect}
              onNodeClick={mergeNodedata}
              nodeTypes={nodeTypes}
            >
              {show && firstNodeInfoClick ? (
                <div className="info-panel">
                  <button
                    className="close-button"
                    onClick={() => {
                      setShow(false);
                      props.setInfoClick(false);
                      props.setShowDetails(false);
                    }}
                  >
                    X
                  </button>
                  <div className="pt-2">
                    <div className="w-100">
                      <Row className="px-2 py-1">
                        <Col className="col-3 p-0">
                          <span className="details-label text-dark">
                            Clicked Node <b> : </b>
                          </span>
                        </Col>
                        <Col className=" col-8 p-0 text-dark">
                          <span>
                            {props.nodeClick}
                          </span>
                        </Col>
                      </Row>
                    </div>

                    {/* <h3>Clicked Node: {props.nodeClick}</h3> */}
                    {/* <br /> */}
                    <DetailsCard
                      data={props.firstdata}
                      certifiedetails={props.firstcertifiedetails}
                      metrics={props.firstmetrics}
                      oneMonthUserVisitCount={props.firstoneMonthUserVisitCount}
                      lineageNode={true}
                    />
                  </div>
                </div>
              ) : null}
              {show && infoOnClick ? (
                <div className="info-panel">
                  <button
                    className="close-button"
                    onClick={() => setShow(false)}
                  >
                    X
                  </button>
                  <h3>Clicked Node: {clickedNodeInfo}</h3>
                  <br />
                  <DetailsCard
                    data={modaldata}
                    certifiedetails={certifiedetails}
                    metrics={metricsdata}
                    oneMonthUserVisitCount={oneMonthUserVisitCount}
                    lineageNode={true}
                  />
                </div>
              ) : null}
              <Controls showInteractive={false} />
              <MiniMap zoomable pannable />
              <Background />
            </ReactFlow>
          )}
        </div>
      </>
      {/* )} */}
    </>
  );
};

export default ReactFlowChart;
